module.exports = __webpack_public_path__ + "img/20m2.ad5d0e79.jpg";